let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5aUoq"), load("tLGOl")]).then(() => parcelRequire('anKEx'));